import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupportService } from '../services/support.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-session-actions-dialog',
  templateUrl: './session-actions-dialog.component.html',
  styleUrls: ['./session-actions-dialog.component.scss'],
  standalone: false
})
export class SessionActionsDialogComponent {

  logs: any
  total: number = 0
  limit: number = 50
  page: number = 1
  logsLoader : boolean = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public supportService: SupportService
  ) { }

  ngOnInit(): void {

    this.loadLogs()

    // this.supportService.getSessionLogs(this.data.id).subscribe({
    //   next: (result: any) => {
    //     this.logs = result.logs || [];
    //     this.total = this.logs.length;
    //   },
    //   error: (err) => {
    //     console.error(err);
    //   }
    // });
  }

  loadLogs() {
    this.logs = []
    this.logsLoader = true

    this.supportService.getSessionLogs(this.data.id, this.page, this.limit).subscribe({
      next: (result: any) => {
        this.logs = result.logs || [];
        this.total = result.total;
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.logsLoader = false
      }
    });
  }

  onPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this.loadLogs();
  }

}